import * as occlTemplates from '@src/components/templates/occl/index.js';
import * as tefOneTemplates from '@src/components/templates/tefOne/index.js';

export type TemplatesType = typeof tefOneTemplates;

export const templates = {
  occl: occlTemplates as unknown as TemplatesType,
  tefOne: tefOneTemplates,
};
